module.exports = __webpack_public_path__ + "img/uid_tip_br.5926828.png";